import { mapObjectize } from 'cityads-v3/utils/apiUtils';

import {
  TOGGLE_MENU,
  ONLOAD_GET_SHOW_MENU_SETTING,
  GET_LAYOUT_DATA,
  GET_LAYOUT_DATA_SUCCESS,
  GET_LAYOUT_DATA_FAIL,
  SET_VISIBLE,
} from "cityads-v3/actions/menu";

import {
  CHECK_AUTH_SUCCESS,
  CHECK_AUTH_FAIL,
} from 'cityads-v3/actions/auth';

const MENU_CLOSED = 0;
const MENU_OVERLAYED = 1;
const MENU_DOCKED = 2;

const initialState = {
  isLoading: false,
  isLoaded: false,
  isFailed: false,
  isAuthChecked: false,
  isVisible: true,

  opened: false,
  docked: false,
  menu: []
};

function getInitialState(state = initialState) {
  const showMenuSetting = getShowMenuSetting(state);
  return Object.assign({}, state, showMenuSetting);
}

function getShowMenuSettingAfterAuthCheck(state) {
  return {
    ...state,
    ...getShowMenuSetting(state)
  }
}


export default function menu(state = getInitialState(), action = {}) {
  switch (action.type) {
    case ONLOAD_GET_SHOW_MENU_SETTING:
      return getShowMenuSettingAfterAuthCheck(state);

    case CHECK_AUTH_SUCCESS:
      return getShowMenuSettingAfterAuthCheck({
        ...state,
        isAuthChecked: true,
        isLoggedIn: true,
      });

    case CHECK_AUTH_FAIL:
      return getShowMenuSettingAfterAuthCheck({
        ...state,
        isAuthChecked: true,
        isLoggedIn: false,
      });


    case TOGGLE_MENU:
      const { opened, docked } = action;

      if (state.isLoggedIn) {
        setShowMenuSetting(opened, docked);
      }

      return {
        ...state,
        opened,
        docked,
      };

    case GET_LAYOUT_DATA:
      return {
        ...state,
        isLoading: true,
      };
    case GET_LAYOUT_DATA_SUCCESS:
      const menu = action.response.data?.menu?.items || [];
      const menuById = mapObjectize(menu, 'k', 'c');

      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        isFailed: false,
        menu,
        menuById,
      };
    case GET_LAYOUT_DATA_FAIL:
      return {
        ...state,
        isLoading: false,
        isFailed: true,
      };

    case SET_VISIBLE:
      return {
        ...state,
        isVisible: action.isVisible
      }

    default:
      return state;
  }
}

function setShowMenuSetting(opened = false, docked = false) {
  let showMenu = MENU_CLOSED;

  if (opened && docked) {
    showMenu = MENU_DOCKED;
  } else if (opened && !docked) {
    showMenu = MENU_OVERLAYED;
  }

  try{
    localStorage.setItem('show_menu', showMenu);
  } catch(err) {
    return null;
  }
}

function getShowMenuSetting(state) {
  try {
    let showMenu = localStorage.getItem('show_menu');
    if (!showMenu) {
      showMenu = state.isAuthChecked && state.isLoggedIn ? MENU_DOCKED : MENU_CLOSED;
    }

    if (state.isAuthChecked && !state.isLoggedIn && showMenu != null) {
      showMenu = MENU_CLOSED;
    }

    return {
      opened: +showMenu > 0,
      docked: +showMenu === MENU_DOCKED,
      initialShowMenu: showMenu
    };

  } catch(err){
    return null;
  }
}
